<app-pop-up-alert
   *ngIf="
      (contactFormHandle && this.submitPage) ||
      (addressFormHandle && this.submitPage) ||
      (addressValidatorHandle && this.submitPage)
   "
></app-pop-up-alert>

<div class="card step mr-auto ml-auto mt-5">
   <div class="card-header step-header" id="address">
      <div class="col-12">
         <div class="d-flex flex-row justify-content-between align-items-center col-12">
            <span class="d-flex align-items-center">
               <span
                  *ngIf="shippingAddress && !editModeOn"
                  class="icon-circle d-flex align-items-center justify-content-center mr-2"
               >
               </span>
               <span class="address"
                  ><span>1. {{ translatePath + 'shipping-address' | translate }}</span></span
               >
            </span>
            <div class="d-flex">
               <button
                  (click)="setEditModeState(true)"
                  *ngIf="shippingAddress && !editModeOn"
                  class="btn btn-outline-info align-self-end d-flex align-items-center justify-content-center"
                  type="button"
               >
                  <span>
                     {{ 'buttons.edit' | translate }}
                  </span>
               </button>
               <button
                  (click)="setEditModeState(false)"
                  *ngIf="shippingAddress && editModeOn"
                  class="btn btn-outline-info align-self-end d-flex align-items-center justify-content-center"
                  type="button"
               >
                  <span>
                     {{ 'buttons.cancel-edit' | translate }}
                  </span>
               </button>
            </div>
         </div>
      </div>
   </div>

   <div #addressStep="ngbCollapse" [(ngbCollapse)]="!expanded">
      <div class="card-body d-flex flex-column">
         <div *ngIf="shippingAddress && !editModeOn" class="d-flex flex-column col-12">
            <h6 class="col-12">{{ translatePath + 'contact-info' | translate }}</h6>

            <div class="col-12">
               <hr class="mt-0" />
            </div>

            <span class="col-12">{{ shippingAddress.firstName }} {{ shippingAddress.lastName }}</span>
            <span class="col-12">{{ shippingAddress.email }}</span>
            <span class="col-12">{{ shippingAddress.phone }}</span>

            <h6 class="col-12 mt-4">{{ translatePath + 'shipping-address' | translate }}</h6>

            <div class="col-12">
               <hr class="mt-0" />
            </div>

            <app-address-block [address]="shippingAddress" class="col-12"></app-address-block>
         </div>

         <div *ngIf="editModeOn" class="d-flex flex-column">
            <div class="col-12 mb-3">
               <span *ngIf="!user" class="col-12">
                  <a (click)="login()" class="text-primary">{{ translatePath + 'signIn' | translate }} </a>
               </span>
            </div>

            <!-- Contact Info  -->
            <div
               *ngIf="contactForm"
               [formGroup]="contactForm"
               class="contact-info d-flex flex-column align-self-center"
            >
               <h6 class="col-12">
                  <span class="col-12">{{ translatePath + 'contact-info' | translate }} </span>
               </h6>

               <div class="col-12">
                  <div class="col-12 pb-1">
                     <hr />
                  </div>
               </div>

               <div class="d-flex flex-column flex-sm-row col-12">
                  <!-- First Name -->
                  <div class="col-12 col-sm-6 form-group">
                     <label>{{ translatePath + 'labels.first-name' | translate }}</label>
                     <input
                        [ngClass]="{
                           'is-invalid': contactForm.get('firstName')?.invalid && contactForm.get('firstName')?.touched,
                           'is-valid': contactForm.get('firstName')?.valid
                        }"
                        class="form-control"
                        formControlName="firstName"
                        placeholder="{{ translatePath + 'placeholders.enter-first-name' | translate }}"
                        type="text"
                     />
                     <div *ngIf="contactForm.get('firstName')?.hasError('required')" class="invalid-feedback">
                        {{ 'validation-errors.required' | translate }}
                     </div>
                     <div *ngIf="contactForm.get('firstName')?.hasError('validationErrors')" class="invalid-feedback">
                        <div *ngFor="let item of contactForm.get('firstName')?.getError('validationErrors')">
                           {{ 'validation-errors.' + item | translate }}
                        </div>
                     </div>
                  </div>
                  <!-- First Name end -->
                  <!-- Last name  -->
                  <div class="col-12 col-sm-6 form-group">
                     <label>{{ translatePath + 'labels.last-name' | translate }}</label>
                     <input
                        [ngClass]="{
                           'is-invalid': contactForm.get('lastName')?.invalid && contactForm.get('lastName')?.touched,
                           'is-valid': contactForm.get('lastName')?.valid
                        }"
                        class="form-control"
                        formControlName="lastName"
                        placeholder="{{ translatePath + 'placeholders.enter-last-name' | translate }}"
                        type="text"
                     />
                     <div *ngIf="contactForm.get('lastName')?.hasError('required')" class="invalid-feedback">
                        {{ 'validation-errors.required' | translate }}
                     </div>
                     <div *ngIf="contactForm.get('lastName')?.hasError('validationErrors')" class="invalid-feedback">
                        <div *ngFor="let item of contactForm.get('lastName')?.getError('validationErrors')">
                           {{ 'validation-errors.' + item | translate }}
                        </div>
                     </div>
                  </div>
                  <!-- Last name end -->
               </div>
               <div class="d-flex flex-column flex-sm-row col-12">
                  <!-- Email -->
                  <div class="col-12 col-sm-6 form-group">
                     <label>{{ translatePath + 'labels.email' | translate }}</label>
                     <input
                        [ngClass]="{
                           'is-invalid': contactForm.get('email')?.invalid && contactForm.get('email')?.touched,
                           'is-valid': contactForm.get('email')?.valid
                        }"
                        class="form-control"
                        formControlName="email"
                        id="email"
                        placeholder="{{ translatePath + 'placeholders.enter-email' | translate }}"
                        type="text"
                     />
                     <div *ngIf="contactForm.get('email')?.hasError('email')" class="invalid-feedback">
                        {{ 'validation-errors.invalid-email' | translate }}
                     </div>

                     <div *ngIf="contactForm.get('email')?.hasError('validationErrors')" class="invalid-feedback">
                        <div *ngFor="let item of contactForm.get('email')?.getError('validationErrors')">
                           {{ 'validation-errors.' + item | translate }}
                        </div>
                     </div>
                  </div>
                  <!-- Email End -->
                  <!-- Phone -->

                  <div class="col-12 col-sm-6 form-group">
                     <label>{{ translatePath + 'labels.phone' | translate }}</label>
                     <form #f="ngForm" [formGroup]="contactForm" class="input-group phone">
                        <ngx-intl-tel-input
                           [cssClass]="cssPhoneValidator()"
                           [enableAutoCountrySelect]="true"
                           [enablePlaceholder]="false"
                           [maxLength]="'15'"
                           [numberFormat]="PhoneNumberFormat.National"
                           [phoneValidation]="true"
                           [preferredCountries]="preferredCountries"
                           [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                           [searchCountryFlag]="true"
                           [selectFirstCountry]="false"
                           [selectedCountryISO]="CountryISO.Moldova"
                           [separateDialCode]="separateDialCode"
                           class="valid-phone"
                           formControlName="phone"
                           name="phone"
                           style="width: 100%"
                        >
                        </ngx-intl-tel-input>
                     </form>
                     <!-- Phone end -->
                  </div>
               </div>
            </div>

            <!-- Contact info end -->
            <!-- Shipping address  -->
            <div *ngIf="addressForm" class="d-flex flex-column mt-4">
               <div class="contact-info mr-auto ml-auto">
                  <h6 class="col-12">
                     <span class="col-12">{{ translatePath + 'shipping-address' | translate }}</span>
                  </h6>
                  <div class="col-12">
                     <div class="col-12 pt-1 pb-2">
                        <hr />
                     </div>
                  </div>
               </div>
               <div *ngIf="user && editModeOn" class="contact-info mr-auto ml-auto form-group col-12">
                  <!-- <div *ngIf="!addresses || addresses?.length==0" class="alert alert-warning w-100">
                            {{translatePath + 'no-saved-addresses' | translate}}
                        </div> -->
                  <!-- <div *ngIf="addresses && addresses.length > 0" class="col-12 form-group">
                     <div class="d-flex flex-column" ngbDropdown>
                        <label>{{ translatePath + 'saved-addresses' | translate }}</label>

                        <button class="form-control address-select-btn" ngbDropdownToggle>
                           <span *ngIf="selectedAddress?.address && !checkShippment">{{
                              selectedAddress?.address
                                 ? getShippingAddressText(selectedAddress?.address)
                                 : (translatePath + 'select-address' | translate)
                           }}</span>
                           <span *ngIf="selectedAddress?.internationalAddress && checkShippment">{{
                              selectedAddress?.internationalAddress
                                 ? getShippingInternationalAddressText(selectedAddress?.internationalAddress)
                                 : (translatePath + 'select-address' | translate)
                           }}</span>
                        </button>

                        <div ngbDropdownMenu>
                           <button
                              (click)="existingAddressSelected(item)"
                              *ngFor="let item of addresses"
                              ngbDropdownItem
                           >
                              <span *ngIf="item.address && !checkShippment">{{
                                 getShippingAddressText(item.address)
                              }}</span>
                              <span *ngIf="item.internationalAddress && checkShippment">{{
                                 getShippingInternationalAddressText(item.internationalAddress)
                              }}</span>
                           </button>
                           <button (click)="useNewAddress()" [disabled]="selectedAddress == null" ngbDropdownItem>
                              <a class="text-primary">
                                 <i class="fas fa-plus"></i
                                 ><span>
                                    {{ translatePath + 'labels.use-new-address' | translate }}
                                 </span>
                              </a>
                           </button>
                        </div>
                     </div>
                  </div> -->
               </div>
               <app-address-form
                  (checkShipp)="getShippment($event)"
                  [addressForm]="addressForm"
                  [hideInternationalCheckbox]="false"
               ></app-address-form>
            </div>
         </div>
         <div class="contact-info mr-auto ml-auto">
            <div *ngIf="!checkShippment" class="col-12">
               <div *ngIf="user && editModeOn" class="form-check col-12">
                  <input [(ngModel)]="doSaveAddress" class="form-check-input" id="doSaveAddress" type="checkbox" />
                  <label class="form-check-label d-flex align-items-center" for="doSaveAddress">
                     <span class="check-label font-weight-bold ml-3 mr-3">
                        {{ translatePath + 'labels.save-address' | translate }}
                     </span>
                  </label>
               </div>
            </div>
            <div *ngIf="editModeOn" class="alert alert-warning m-4">
               <span class="font-weight-bold">
                  {{ translatePath + 'labels.be-sure' | translate }}
               </span>
            </div>
            <div class="col-12 mr-auto ml-auto mb-3 mt-3" style="position: relative; height: 59px">
               <p *ngIf="loading" class="progress-bar-custom" style="max-width: 298px">
                  <ngb-progressbar
                     [animated]="true"
                     [showValue]="false"
                     [value]="valueBar"
                     id="bar"
                     textType="white"
                     type="info"
                  ></ngb-progressbar>
                  <span *ngIf="valueChecking" class="checkbox-custom">
                     <input
                        [checked]="true"
                        class="checkbox-custom"
                        id="checkbox-2"
                        name="checkbox-2"
                        type="checkbox"
                     />
                     <label class="checkbox-custom-label" for="checkbox-2"></label>
                  </span>
               </p>

               <p *ngIf="loading" class="mr-auto ml-auto text-center d-flex align-items-end justify-content-center">
                  <span class="mt-5 text-center user-info">
                     {{ 'public.shipping-details.user-info' | translate }}
                  </span>
               </p>
               <div
                  [ngClass]="{'btn-class': loading, display: loading}"
                  class="col-12 d-flex flex-row justify-content-end"
               >
                  <button
                     (click)="confirmAddress()"
                     *ngIf="editModeOn"
                     [disabled]="addressForm.invalid"
                     class="h-auto btn btn-primary btn-sm text-capitalize"
                     type="button"
                  >
                     <span>
                        {{ 'buttons.confirm' | translate }}
                     </span>
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
